module.exports = __webpack_public_path__ + "static/media/pizza.d0c05340.svg";